module.exports = __webpack_public_path__ + "static/media/elephant-eating.b92d554b.gif";